import { render, staticRenderFns } from "./HornorBuyGuideNormal.vue?vue&type=template&id=6f934740&scoped=true&"
import script from "./HornorBuyGuideNormal.vue?vue&type=script&lang=js&"
export * from "./HornorBuyGuideNormal.vue?vue&type=script&lang=js&"
import style0 from "./HornorBuyGuideNormal.vue?vue&type=style&index=0&id=6f934740&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f934740",
  null
  
)

export default component.exports